export default __webpack_public_path__ + "static/media/prod2.79dadd49.png";